module.exports = __webpack_public_path__ + "static/media/download_icon.7bb05874.svg";